import React, { useCallback, useState } from 'react';
import { DEBOUNCE_INPUT_DELAY } from '../../../configuration';

export const DebouncedInput: React.FC<any> = React.memo(({ value: initialValue, onChange, debounce = DEBOUNCE_INPUT_DELAY, ...props }) => {
    const [value, setValue] = useState(initialValue);
    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const currentValue = e.target.value;
            setValue(currentValue);
            const timeoutId = setTimeout(() => onChange(currentValue), debounce);
            return () => clearTimeout(timeoutId);
        },
        [onChange, debounce]
    );
    return <input {...props} value={value} onChange={handleChange} />;
});
